import { Badge } from "@/components/ui/badge";
import type { ImportJobStatus } from "@/lib/types/itsm-import";

const STATUS_CONFIG: Record<
  ImportJobStatus,
  { label: string; variant: "default" | "secondary" | "destructive" | "outline"; className?: string }
> = {
  pending: { label: "Pending", variant: "outline" },
  fetching: { label: "Fetching", variant: "default", className: "bg-blue-600 hover:bg-blue-600" },
  processing: { label: "Processing", variant: "default", className: "bg-amber-500 hover:bg-amber-500 animate-pulse" },
  completed: { label: "Completed", variant: "default", className: "bg-green-600 hover:bg-green-600" },
  failed: { label: "Failed", variant: "destructive" },
  cancelled: { label: "Cancelled", variant: "secondary" },
};

export function JobStatusBadge({ status }: { status: ImportJobStatus }) {
  // eslint-disable-next-line security/detect-object-injection
  const config = STATUS_CONFIG[status];
  return (
    <Badge variant={config.variant} className={config.className}>
      {config.label}
    </Badge>
  );
}
